export default __webpack_public_path__ + "static/media/logo.6897fbe1.svg";